import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import "../styles/AboutStory.css";

gsap.registerPlugin(ScrollTrigger);

const storyData = [
  {
    title: "Escape the Noise",
    text: "Step away from crowded cities and rediscover silence in the Himalayas.",
    image: "https://images.unsplash.com/photo-1501785888041-af3ef285b470"
  },
  {
    title: "Reconnect with Nature",
    text: "Wake up to mountain air, flowing rivers, and endless landscapes.",
    image: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee"
  },
  {
    title: "Find Inner Stillness",
    text: "Through yoga, meditation, and mindful living.",
    image: "https://images.unsplash.com/photo-1500534314209-a25ddb2bd429"
  }
];

function AboutStory() {
  const containerRef = useRef(null);

  useEffect(() => {
    const sections = gsap.utils.toArray(".story-step");

    sections.forEach((section) => {
      const image = section.querySelector(".story-image");

      gsap.fromTo(
        image,
        { scale: 1.3, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          scrollTrigger: {
            trigger: section,
            start: "top center",
            end: "bottom center",
            scrub: true
          }
        }
      );
    });
  }, []);

  return (
    <section className="about-story" ref={containerRef}>
      {storyData.map((step, index) => (
        <div className="story-step" key={index}>
          <div className="story-text">
            <h2>{step.title}</h2>
            <p>{step.text}</p>
          </div>

          <div className="story-image">
            <img src={step.image} alt={step.title} />
          </div>
        </div>
      ))}
    </section>
  );
}

export default AboutStory;